import { useCallback, useState } from 'react'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { useFetchOne } from 'utils/api/useFetch'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import {
  TransactionDetailsPlatformTransferGeneralForm,
  TransactionDetailsPlatformTransferGeneralProps,
} from './TransactionDetailsPlatformTransferGeneralForm'

export const TransactionDetailsPlatformTransferGeneralPage: React.FC<
  TransactionDetailsPlatformTransferGeneralProps
> = (props) => {
  const [isEdit, setEdit] = useState(false)
  const walletsApiClient = useApiClient(WalletsApiClient)
  const callback = useCallback(async () => {
    return await walletsApiClient.getTransactionNotesByTransactionId(props.transaction.id)
  }, [props.transaction.id]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data: notes, isLoading } = useFetchOne(callback)

  return (
    <Loading isLoading={isLoading}>
      {notes && (
        <TransactionDetailsPlatformTransferGeneralForm
          {...props}
          notes={notes}
          isEdit={isEdit}
          setEdit={setEdit}
        />
      )}
    </Loading>
  )
}
